"use client";

import React from "react";
import { cn } from "@/lib/utils";
import Link from "next/link";
import { handleSmoothScroll } from "@/lib/utils/smooth-scroll";

type AnchorItem = {
  title: string;
  href: string;
};

export interface AnchorListItemsProps {
  items: AnchorItem[];
}

const AnchorListItems: React.FC<AnchorListItemsProps> = ({ items }) => {
  return (
    <div className="flex flex-col flex-wrap divide-neutral-300 sm:flex-row md:divide-x">
      {items?.map((item, index) => {
        return (
          <Link
            key={`${item.title}-${index}`}
            href={item.href}
            className={cn(
              "bg-white p-2 font-montserrat text-subheading-3-500 text-secondary-500 transition-colors duration-300 ease-out hover:bg-secondary-500 hover:text-secondary-100 md:px-3 md:py-2"
            )}
            onClick={(e) => handleSmoothScroll(e, item.href)}
          >
            {item.title}
          </Link>
        );
      })}
    </div>
  );
};

export default AnchorListItems;
